 (function() {
  $(document).ready(function(){
  
  	$(document).on("swell:setup", function() {
      $('.thank-you-popup').css('display', 'block');
  	  Swell.Referral.initializeReferral(".swell-referral", SwellConfig.Referral.opts);
      SwellConfig.setupReferrals.populateReferrals(".table-data");
      Swell.Campaign.initializeCampaigns(".swell-campaign-list", SwellConfig.Campaign.opts);
      SwellConfig.Redemption.initializeFixedAmount('.swell-fixed-amount-redemption-option-list');
      SwellConfig.Redemption.initializeSubscriptionRedemptions('.swell-subscription-based-redemption-option-list');
      swellAPI.refreshEmbeds();
      SwellConfig.tiers.setupTiers();
      // if(spapi.authenticated) {
      //   SwellConfig.Tier.setupCustomerTierStatus();
      // }
      if (spapi.customer.vip_tier) {
        $('.login-detail.tier-expiry').html('Your tier status expires at: <span class="tier-expiry-date">xxx</span>');
        var date = new Date(spapi.customer.vip_tier_expiration_date);
        $('.tier-expiry-date').html((date.getUTCMonth() + 1) + "/" + date.getDate() + "/" + date.getFullYear());  
      }
  	});
    
    $("body").on("click", ".swell-share-referral-copy", function () {
      setTimeout(function () {
        $(".swell-referral-copy-link").html($(".swell-referral-copy-link").html()+"?c");
      }, 20);
    });

    $('body').on('click', '.swell-referral-back-link.close-thank-you', function() {
    	$('.thank-you-popup').remove();
    });

    $(".swell-link-redeem").on("click", function(e) {
      $('html, body').animate({
        scrollTop: $("#followed-section").offset().top,
        'slow': 'slow'
      });
    });
  });

}).call(this);

 (function() {
   window.SwellConfig = window.SwellConfig || {};

   SwellConfig.setupReferrals = {
     populateReferrals: function(containerSelector) {
       details = swellAPI.getCustomerDetails();
       
       if (details.referrals.length != 0) {
         // $(".refer-details").removeClass("hide");
         $.each(details.referrals, function( index, item ) {
           status = "Invited";
           if (item.completedAt != null){
             status =  "<span>Purchased</span>"+" ("+spapi.activeReferralCampaign.reward_text + " earned" +")";
           }
           $(containerSelector).append("<tr><td>"+ item.email+ "</td><td>" + status + "</td></tr>");
           if ($('.table').height() >= 200) {
             $(".table-classes").addClass("table-responsive");
           }
         });
       }

       return 
     }
   };

 }).call(this);

 (function() {
   window.SwellConfig = window.SwellConfig || {};

   SwellConfig.tiers = {
     setupTiers: function() {
        var stats = spapi.customer.vip_tier_stats;
        if (stats) {
          var amountSpend = stats.amount_spent_cents/100;
          $('.total-spend').html(amountSpend);
          var wellDoneTier = spapi.activeVipTiers[0].amount_spent_cents / 100;
          var mediumTier = spapi.activeVipTiers[1].amount_spent_cents / 100;
          if (amountSpend < wellDoneTier) {
            $('.welldone').prepend('<div class="current-status">Current Tier<p>( Spend '+ (wellDoneTier - amountSpend) +' more to earn medium )</p></div>');
            $('.welldone').removeClass('swell-active');
          } else if (amountSpend < mediumTier) {
            $('.medium').prepend('<div class="current-status">Current Tier<p>( Spend '+ (mediumTier - amountSpend) +' more to earn rare )</p></div>');
            $('.medium').removeClass('swell-active');
          } else if (amountSpend >= mediumTier) {
            $('.rare').prepend('<div class="current-status">Current Tier</div>');
            $('.rare').removeClass('swell-active');
          }
        }
     }
   };

 }).call(this);

 (function() {
   window.SwellConfig = window.SwellConfig || {};

   SwellConfig.Redemption = {
     initializeFixedAmount: function(containerSelector) {
      $.each(spapi.activeRedemptionOptions, function(index, item) {
        if (item.discount_type === "fixed_amount") {
          $(containerSelector).append(`
          <a class="swell-redemption-option">
            <div class="swell-redemption-option-content swell-redemption-link" data-redemption-option-id="${item.id}">
            <div class="swell-redemption-option-cost">${item.prettyDiscount}</div>
            =
            <div class="swell-redemption-option-value">${item.cost_text}</div>
            </div>
          </a>`);
        }
      });
     },
     initializeSubscriptionRedemptions: function(containerSelector) {
      $.each(spapi.activeRedemptionOptions, function(index, item) {
        if (item.discount_type === "custom") {
          $(containerSelector).append('<li class="swell-redemption-option"> <div class="swell-redemption-option-content swell-redemption-link" data-redemption-option-id='+item.id+'> <div class="swell-redemption-option-cost">'+ item.name.split(" ")[0] +'</div> <div class="swell-redemption-option-value">'+ item.cost_text+'</div> </div> </li>');
        }
      });
     }
   };

 }).call(this);


(function() {
  window.SwellConfig = window.SwellConfig || {};

  SwellConfig.Referral = {
    opts: {
      localization: {
        referralSidebarDetailsAction: "REFER A FRIEND",
        referralSidebarDetailsReward: "",

        referralRegisterHeading: "GIVE $5, GET $5",
        referralRegisterFormDetails: "",
        referralRegisterFormEmail: "Submit your email to get started",
        referralRegisterFormSubmit: "Next",
        

        referralReferHeading: "GIVE $5, GET $5",
        referralReferFormEmails: "your friends’ emails (separated by commas)",
        referralReferFormSubmit: "Send",
        referralReferFormDetails: "",
        referralReferFormEmailsDetails: "",
        

        referralReferMediaDetails: "You can also share your link with the buttons below.",

        referralShareFacebook: "Share",
        referralShareTwitter: "",
        referralShareCopy: "Copy Link",
        referralShareSMS: "sms",

        referralFacebookIcon: "swell-icon-facebook",

        referralThanksHeading: "Thanks for Referring!",
        referralThanksDetails: "Remind your friends to check their emails.",

        referralCopyHeading: "",
        referralCopyButton: "Copy Link",
        referralCopyDetails: "Copy and share link with your friends"
     },
      templates: {
        referral: '<div class="swell-referral-content-container"> <div class="swell-referral-content-sidebar"> <% if(referralCampaign.background_image_url && referralCampaign.background_image_url != null) { %> <img class="swell-referral-sidebar-image" src="<%= referralCampaign.background_image_url %>" alt="Refer a friend"> <% } %> <div class="swell-referral-sidebar-details"> <h1 class="swell-referral-sidebar-details-action"><%= localization.referralSidebarDetailsAction %></h1> </div> </div> <siv class="seperator"></siv> <div class="swell-referral-content-main"></div> </div>',
        referralRegister: '<div class="swell-referral-register"> <h2 class="swell-referral-heading"><%= localization.referralRegisterHeading %></h2> <p class="swell-referral-details"><%= localization.referralRegisterDetails %></p> <div class="swell-referral-border"></div> <div class="swell-referral-form-wrapper"> <form name="swell-referral-register-form" id="swell-referral-register-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"><%= localization.referralRegisterFormDetails %></p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="email" name="swell-referral-register-email" id="swell-referral-register-email" required="required" placeholder="<%= localization.referralRegisterFormEmail %>"></li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-register-submit" id="swell-referral-register-submit" value="<%= localization.referralRegisterFormSubmit %>"> </li> </ul> </div> </form> </div> </div> ',
        referralRefer: '<div class="swell-referral-refer"> <h2 class="swell-referral-heading"><%= localization.referralReferHeading %></h2> <p class="swell-referral-details"> <%= localization.referralReferDetails %> </p> <div class="swell-referral-border"></div> <div class="swell-referral-form-wrapper"> <form class="swell-referral-form" name="swell-referral-refer-form" id="swell-referral-refer-form" method="POST" action="."> <div class="swell-referral-form-header"> <p class="swell-referral-form-header-details"> <%= localization.referralReferFormDetails %> </p> </div> <div class="swell-referral-form-body"> <ul class="swell-referral-form-list"> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-field-input" type="text" name="swell-referral-refer-emails" id="swell-referral-refer-emails" required="required" placeholder="<%= localization.referralReferFormEmails %>"> </li> <li class="swell-referral-form-list-field"> <input class="swell-referral-form-list-submit" type="submit" name="swell-referral-refer-submit" id="swell-referral-refer-submit" value="<%= localization.referralReferFormSubmit %>"> </li> </ul> </div> <span class="swell-referral-form-field-details"></span> </form> </div> <div class="swell-referral-media-wrapper"> <p class="swell-referral-media-details"> <%= localization.referralReferMediaDetails %> </p> <ul class="swell-referral-media-list"> <li class="swell-referral-medium swell-share-referral-facebook"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralFacebookIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareFacebook %> </div> </li> <li class="swell-referral-medium swell-share-referral-sms"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-message" aria-hidden="true"></i>&nbsp;SMS</div> </li> <li class="swell-referral-medium swell-share-referral-messenger"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon swell-icon-Message" aria-hidden="true"></i>&nbsp;Message</div> </li> <li class="swell-referral-medium swell-share-referral-copy"> <div class="swell-referral-medium-content"> <i class="swell-referral-media-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp; <%= localization.referralShareCopy %> </div> </li> </ul> </div> </div>',
        referralCopy: '<div class="swell-referral-copy"> <div class="swell-referral-copy-content"> <div class="swell-referral-copy-sidebar"></div> <div class="swell-referral-copy-main"> <div class="close-icon-holder"><span class="swell-referral-back-link"></span></div> <h2 class="swell-referral-heading"> <i class="swell-referral-heading-icon <%= localization.referralLinkIcon %>" aria-hidden="true"></i>&nbsp;<%= localization.referralCopyHeading %> </h2> <div class="swell-referral-form-wrapper"> <div class="swell-referral-copy-link" id="swell-referral-copy-link"><%= customer.referralLink %></div> <button class="swell-referral-copy-button" id="swell-referral-copy-button" data-clipboard-target="#swell-referral-copy-link"><%= localization.referralCopyButton %></button> <p class="swell-referral-details"><%= localization.referralCopyDetails %></p> </div> </div> </div> <div>'
      }
    },
    populateReferrals: function(){
        var referral_receipts = spapi.customer.referral_receipts;
        referral_receipts.forEach(function(referral_receipt) {
          var email = referral_receipt.email;
          var completed_at = referral_receipt.completed_at;
          if (completed_at) {
            status = "Purchased (" + spapi.activeReferralCampaign.reward_text + ")";
          } else {
            status = 'Invited';
          }
          $(".swell-referral-tbody").append("<tr><td>" + email + "</td><td>" + status + "</td></tr>");
        });
    }
  };

}).call(this);


 (function() {
   window.SwellConfig = window.SwellConfig || {};

   SwellConfig.Campaign = {
     opts: {
       templates: {
         campaign: '<li class="swell-campaign" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-content" data-display-mode="modal" data-campaign-id="<%= campaign.id %>"> <div class="swell-campaign-icon"> <span class="swell-campaign-icon-content"><i class="<%= campaign.icon %> id<%= campaign.id %>"><span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span> </i> </span> </div> <div class="swell-campaign-value"> <span class="swell-campaign-value-content"><%= campaign.reward_text %></span> </div> <div class="swell-campaign-type"> <span class="swell-campaign-type-content"><%= campaign.title %></span> </div> </div> </li>'
       }
     }
   };

 }).call(this)